<template>
	<div>
		<Header />
		<div class="bannerWrap">
			<img class="bannerImg" :src="`${imgPath}/static/assets/img/news/banner.jpg?2`" />
			<cloud />
		</div>
		<div class="noticeWrap">
            <news-item :NoticeItem="item" v-for="(item,index) in noticeList" :key="index" />
		</div>
		<div class="arrowTop" @click="getNews" v-if="allpage>page">
			<div><img :src="`${imgPath}/static/assets/img/arrow_top.png`" /></div>
			<p>{{ $t('more') }}</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				noticeList:[],
				page:1,
				allpage:1
			}
		},
		async mounted() {
			this.getNews();
		},
		methods:{
			async getNews(){
				let data = await this.$util.getNoticeList({cate:1,page:this.page,lang:localStorage.getItem('language') || 'zh-cn'});
				this.allpage = data.pages.allpage;
				if(data.pages.allpage > this.page){
					this.page++;
				}
				this.noticeList = this.noticeList.concat(data.list);
			}
		}
	}
</script>
<style lang="scss" scoped>
	.bannerWrap{
		position: relative;
		width: 100%;
		.bannerImg {
			width: 100%;
		}
	}
	.noticeWrap{
		padding: 0 0.4rem 0.8rem;
		box-sizing: border-box;
	}
	.arrowTop{
		width: 1.6rem;
		margin: 0.4rem auto;
		>div {
			width: 0.3rem;
			margin: 0 auto;
			>img {
				display: block;
				width: 100%;
				transform: rotate(180deg);
			}
		}
		>p{
			font-size: 0.26rem;
			color: #000000;
			margin-top: 0.2rem;
			text-align: center;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/news/index.vue